var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19278"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 17816"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 54"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 14741"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.316 12.409a3.643 3.643 0 0 1 3.643-3.643M15.669 12.481a3.64 3.64 0 0 1-3.773 3.5h-.008",
  "data-name": "Path 1584"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.206 19.388a9.2 9.2 0 0 0 2.751.422c3.593 0 6.941-2.121 9.275-5.784.916-1.435.916-1.811 0-3.25a16 16 0 0 0-1.071-1.486M15.945 5.905A9.35 9.35 0 0 0 11.959 5c-3.591 0-6.94 2.116-9.271 5.78-.916 1.435-.916 1.811 0 3.25a15.5 15.5 0 0 0 1.324 1.791",
  "data-name": "Path 1585"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.363 5 4.246 19.81",
  "data-name": "Path 1686"
}))))));
export { SvgEyeClose as ReactComponent };
export default __webpack_public_path__ + "static/media/eye_close.71b8441dba9b23b901e76ec7c37192e0.svg";